import * as React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Card from '../../../sharedComponents/core/Cards/Card';
import { Theme } from 'helpers/theme';

const ELEVATED_SHADOW =
  '0 70px 20px 0 rgba(209, 209, 209, 0.00), 0 45px 18px 0 rgba(209, 209, 209, 0.01), 0 25px 15px 0 rgba(209, 209, 209, 0.05), 0 11px 11px 0 rgba(209, 209, 209, 0.09), 0 3px 6px 0 rgba(209, 209, 209, 0.10)';

const useStyles = createUseStyles((theme: Theme) => ({
  cardRoot: {
    height: '100%',
    boxShadow: ELEVATED_SHADOW,
    background: '#FAFBFC'
  },
  card: {
    padding: '22px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
    boxSizing: 'border-box',
    minWidth: 220
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  iconContainer: {
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: '#EEF0F4',
    borderRadius: 8,
    fontSize: 14,
    color: '#9aa0b8'
  },
  title: {
    fontWeight: 800,
    fontSize: 14,
    color: '#9aa0b8'
  },
  description: {
    fontSize: 12,
    color: '#9aa0b8',
    marginTop: 2
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    textAlign: 'center'
  },
  bodyTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: '#6A728F'
  },
  bodyText: {
    fontSize: 12,
    color: '#9aa0b8',
    maxWidth: 200
  },
  bars: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    marginTop: 4
  },
  bar: {
    height: 8,
    borderRadius: 4,
    background: '#EEF0F4'
  }
}));

type Props = {
  icon: IconDefinition;
  title: string;
  message: string;
  className?: string;
};

export default function EmptyStateCard({
  icon,
  title,
  message,
  className
}: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Card
      className={classNames(classes.cardRoot, className)}
      padding="none"
    >
      <div className={classes.card}>
        <div className={classes.header}>
          <div className={classes.iconContainer}>
            <FontAwesomeIcon icon={icon} />
          </div>
          <div>
            <div className={classes.title}>{title}</div>
            <div className={classes.description}>No data yet</div>
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.bars}>
            <div className={classes.bar} style={{ width: '70%' }} />
            <div className={classes.bar} style={{ width: '45%' }} />
            <div className={classes.bar} style={{ width: '60%' }} />
          </div>
          <div className={classes.bodyText}>{message}</div>
        </div>
      </div>
    </Card>
  );
}
